var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"PublicPage"}},[_vm._v("\n    this is public page\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }